import { getRoutes, handleErrorToast } from "@/utils/helpers";
import storage from "@/utils/storage";
import { useNavigate } from "react-router-dom";
import { sdk } from "@/config/medusa";
import { toast } from "sonner";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Forms } from "@/types/form";

const useSettings = () => {
  const navigate = useNavigate();
  const routes = getRoutes();
  const vid = storage.getItem("vid");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Forms["Vendor"]) => {
      return await sdk.client.fetch(`/vendor/${vid}`, {
        method: "PUT",
        body: data,
      });
    },
    onMutate: async (newData) => {
      await queryClient.cancelQueries({ queryKey: ["vendor", vid] });
      const prevData = queryClient.getQueryData<Forms["Vendor"]>(["vendor"]);

      queryClient.setQueryData<Forms["Vendor"]>(["organization"], (data) => {
        return { ...data, ...newData };
      });

      return { prevData };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", vid] });
      toast.success("Settings updated successfully");
      navigate(routes.dashboard);
    },
    onError: (error, __, context) => {
      queryClient.setQueryData<Forms["Vendor"]>(["vendor"], context?.prevData);
      handleErrorToast(error);
    },
  });
};

export { useSettings };
